export default {
  "form.required": "Không được để trống",
  "form.maxLength": "Không được vượt quá {max} ký tự",
};
